<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{ title }}</h4>
  <button
    type="button"
    class="close"
    aria-label="Close button"
    aria-describedby="modal-title"
    (click)="modal.dismiss('')"
  >
    <span class="fas fa-times"></span>
  </button>
</div>
<div class="modal-body">
  <div class="onboarding-content">
    <p>
      <strong [innerHtml]="message"></strong>
    </p>
    <p *ngIf="showInfo">
      {{ 'Common.DeleteText' | translate }}
      <span class="text-danger">{{ 'Common.CanTrevert' | translate }}</span>
    </p>
    <div class="custom-control custom-checkbox confirm-check" *ngIf="requireConfirmation">
      <input
        type="checkbox"
        class="custom-control-input"
        id="confirm-modal-check"
        name="confirm-modal-check"
        [(ngModel)]="confirmed"
      />
      <label class="custom-control-label" for="confirm-modal-check">{{ confirmationLabel }}</label>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Abbrechen</button>
  <button
    type="button"
    ngbAutofocus
    class="btn btn-danger"
    [disabled]="requireConfirmation && !confirmed"
    (click)="modal.close('ok')"
  >
    {{ buttonText }}
  </button>
</div>
